import React, { memo } from 'react'
import ResponsiveImage from 'components/ResponsiveImage'
import Page from 'components/Page'
import usePageProps from 'hooks/usePageProps'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import useMediaQuery from '@mui/material/useMediaQuery'
import RelatedPosts from 'components/RelatedPosts'
import Head from 'next/head'
import sx from './styles'

const BlogDetail = () => {
  const { post, relatedPosts, locale } = usePageProps()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  return (
    <Page>
      <Head>
        <title>
          {locale === 'es' ? post?.name_es : post?.name_en}
        </title>
        <meta
          name="description"
          content={locale === 'es' ? post?.name_es : post?.name_en}
        />
      </Head>
      <Container maxWidth={false}>
        <Grid container>

          <Grid
            xs={12}
            item
            mt={4}
          >
            <Typography variant="h1">
              {locale === 'es' ? post?.name_es : post?.name_en}
            </Typography>
          </Grid>

          <Grid
            xs={12}
            item
            mt={4}
          >
            <Box>

              {post?.big_image && (
                <ResponsiveImage
                  src={post?.big_image}
                  title={post?.name}
                  alt={`entrada - ${post?.name}`}
                  width={isMobile ? 992 : 1920}
                  height={300}
                  className="image-rounded"
                  unoptimize
                />
              )}
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
          >
            <Box
              mt={4}
              sx={sx.content}
            >
              <div dangerouslySetInnerHTML={{ __html: locale === 'es' ? post?.description_es : post?.description_en }} />
            </Box>
            <Divider />
          </Grid>

          <Grid
            item
            xs={12}
            mt={4}
          >
            <RelatedPosts
              items={relatedPosts}
              title="BLOG_OTHERS_XPERIENCES"
            />
          </Grid>

        </Grid>
      </Container>
    </Page>
  )
}

export default memo(BlogDetail)
